export const selectLeaveEntryData = (state) =>
  state.approval.leaveEntryData;

export const selectLeaveEntryLoading = (state) =>
  state.approval.loading;

export const seletctLeaveRequestMeta = (state) =>
  state.approval.meta;

export const selectApprovalLoading = (state) =>
  state.approval.approvalLoading;

export const selectApprovalSuccess = (state) =>
  state.approval.approvalSuccess;

export const selectApprovalError = (state) =>
  state.approval.approvalError;

export const selectManualEntryData=(state)=>
state.approval.manualEntryData?.data;

export const selectManualMeta=(state)=>
state.approval.manualMeta;